import React, { useEffect, useState } from 'react';
import { Title } from 'react-admin';
import GoogleMap from './mapper/GoogleMap';
import { vehicleToMarker } from './mapper/LocationHelper';
import { getZ3PConfigValue } from './helper';
import { fetchTraccarVehicleLocations } from './traccar';

const GPSTracker = () => {
  const [vehicleLocations, setVehicleLocations] = useState([]);

  useEffect(() => {
    fetchTraccarVehicleLocations().then((positionData) => {
      setVehicleLocations(positionData);
    });
  }, []);

  const boundBox = getZ3PConfigValue('lat_lng_bounds');
  let bounds = {};
  if (window.google) {
    const latLngBounds =
      boundBox?.length === 4
        ? [
            { lat: boundBox[0], lng: boundBox[1] },
            { lat: boundBox[2], lng: boundBox[3] },
          ]
        : [
            { lat: 40.774112, lng: -74.691538 },
            { lat: 44.988431, lng: -69.740864 },
          ];
    bounds = new window.google.maps.LatLngBounds();
    bounds.extend(latLngBounds[0]);
    bounds.extend(latLngBounds[1]);
  }

  const vehicleMarkers = vehicleLocations.map(vehicleToMarker);

  return (
    <span>
      <Title title="resources.gps-tracker.title" />
      <GoogleMap
        className="mapperMain2"
        bounds={bounds}
        markers={vehicleMarkers}
        includeTraffic
        enableScrollWheel
        useGoogleMapStyle={false}
        style={{
          position: 'absolute',
          marginTop: '20px',
          width: 'calc(100vw - 280px)',
          height: 'calc(100vh - 100px)',
        }}
      />
    </span>
  );
};

export default GPSTracker;
